import React, { useState } from "react";
import {CompactTestResultCard} from "./testResultView";
interface ReviewPushTabProps {
  policyCode: string;
  state: {
    fileName: string;
    commit_message: string;
    provider: string;
  };
  testResult: any;
  showRetest: boolean;
  showProgress: boolean;
  onFileNameChange: (value: string) => void;
  onCommitMessageChange: (value: string) => void;
  onPushToGit: () => void;
  onDownload: () => void;
}


const ReviewPushTab: React.FC<ReviewPushTabProps> = ({
  policyCode,
  state,
  testResult,
  showRetest,
  showProgress,
  onFileNameChange,
  onCommitMessageChange,
  onPushToGit,
  onDownload
}) => {
  const [tab, setTab] = useState("push");

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Review & Push</h2>
      <div className="space-y-4">
        <label className="font-medium text-sm">Generated Sentinel Policy</label>
        <pre className="p-3 border rounded bg-slate-50 max-h-64 overflow-auto text-xs font-mono">
          {policyCode}
        </pre>

        <div>
          <label className="font-medium text-sm">Validation Result</label>
          <pre
            className={`mt-1 p-2 rounded w-full ${
              !showRetest ? "text-green-600" : "text-red-600"
            }`}
          >
            {showRetest ? "Validation Failed" : "Validated Successfully"}
          </pre>
        </div>

        {testResult && (
          <div className="border rounded p-3">
            <h3 className="font-semibold mb-2">Test Summary</h3>
           <div className="flex items-center p-2 w-full">
                          <CompactTestResultCard data={testResult} />
                          </div>
          </div>
        )}

        <div className="">
          {/* Card */}
          <div className="border rounded-lg shadow-sm p-4 bg-white">
            <div className="flex gap-6 border mb-4 text-sm">
              <button
                onClick={() => setTab("push")}
                className={
                  tab === "push"
                    ? "font-semibold bg-primary text-white rounded px-4 py-2"
                    : "text-gray-500"
                }
              >
                Push Policy
              </button>

              <button
                onClick={() => setTab("download")}
                className={
                  tab === "download"
                    ? "font-semibold bg-primary text-white rounded px-4 py-2"
                    : "text-gray-500"
                }
              >
                Download Policy
              </button>
            </div>

            <div className="text-sm text-gray-700">
              {tab === "push" && (
                <div>
                  <div className="mb-1">
                    <label className="font-medium text-sm">
                      File Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      className="mt-1 border p-2 rounded w-full"
                      value={state.fileName}
                      onChange={(e) => onFileNameChange(e.target.value)}
                      placeholder="File Name"
                    />
                  </div>
                  <div className="mb-1">
                    <label className="font-medium text-sm">Cloud Provider</label>
                    <input
                      className="mt-1 border p-2 rounded w-full"
                      value={state.provider}
                      placeholder=""
                      disabled
                    />
                  </div>
                  <div className="mb-1">
                    <label className="font-medium text-sm">
                      Commit Message <span className="text-red-500">*</span>
                    </label>
                    <input
                      className="mt-1 border p-2 rounded w-full"
                      value={state.commit_message}
                      onChange={(e) => onCommitMessageChange(e.target.value)}
                      placeholder="eg: feat: Add policy/fix:update policy"
                    />
                  </div>
                  <div className="flex gap-2">
                    <button
                      className="px-4 py-2 text-white rounded bg-primary disabled:opacity-50 disabled:cursor-not-allowed"
                      onClick={onPushToGit}
                      disabled={showProgress || state.fileName === "" || state.commit_message === ""}
                    >
                      Push to Git
                    </button>
                  </div>
                </div>
              )}
              {tab === "download" && (
                <div>
                  <button
                    className="px-4 py-2 text-white rounded bg-primary disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={onDownload}
                    disabled={showProgress}
                  >
                    Download
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewPushTab;
